import ButterToast from 'butter-toast';
import CompleteToastContent from "./CompleteToastContent";

export function showSuccessfulToast ({
    fileName = fileName ?? "",
    large = false,
    scheme = "SCHEME_BLUE",
    message = "",
    title,
    showLink = true,
    history,
    companyId,
  }) {

    return ButterToast.raise({
      content: (
        <CompleteToastContent
          fileName={fileName}
          large={large}
          scheme={scheme}
          message={message}
          title={title}
          showLink={showLink}
          history={history}
          companyId={companyId}
        />
      ),
      sticky: true,
    });
  };